(function() {
    'use strict';

    angular
        .module('editorApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'oitozero.ngSweetAlert',
            'common.service',
            'image.service',
            'modules.service',
            'ui.router',
            'ui.sortable',
            'infinite-scroll',
            'ngDraggable',
            'ngWebSocket',
            'angularLazyImg'
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            // 'angular-loading-bar'
            // 'monospaced.qrcode'
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler'];

    function run(stateHandler, translationHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
    }
})();
